import { combineReducers } from 'redux'
import { DEFAULT_PAGINATION_ENTRIES } from 'services/api'
import { getType } from 'typesafe-actions'
import { insertItem, removeItem } from 'utils-next/arrays'

import { addOrganizationModalReducer } from '../components/AddOrganizationModal/duck/reducers'
import { ADD_ORGANIZATION_MODAL_STORE_ID } from '../components/AddOrganizationModal/duck/types'
import {
  checkOrganizationMatchStatus,
  closeDeletePopup,
  dataExtraction,
  openDeletePopup,
  OrganizationsManagerAction,
  resetSearch,
  updateCurrentPage,
  updateSearch,
} from './actions'
import { OrganizationsManagerDeletePopupState, OrganizationsManagerState } from './types'

export const organizationsManagerReducer = combineReducers<OrganizationsManagerState, OrganizationsManagerAction>({
  currentOrganizationId: () => null,
  currentPage: (currentPage = 0, action) => {
    switch (action.type) {
      case getType(updateCurrentPage):
        return action.payload.nextPage
      case getType(updateSearch):
      case getType(resetSearch):
        return 0
      default:
        return currentPage
    }
  },
  limit: (limit = DEFAULT_PAGINATION_ENTRIES, action) => {
    switch (action.type) {
      default:
        return limit
    }
  },
  search: (search = '', action) => {
    switch (action.type) {
      case getType(updateSearch):
        return action.payload.search
      case getType(resetSearch):
        return ''
      default:
        return search
    }
  },
  organizationsBeingAnalyzed: (organizationIds = [], action) => {
    switch (action.type) {
      case getType(checkOrganizationMatchStatus.request): {
        const organization = action.payload
        return insertItem(organizationIds, organization.id)
      }
      case getType(dataExtraction.request):
        return insertItem(organizationIds, action.payload)
      case getType(checkOrganizationMatchStatus.success): {
        const { organization } = action.payload
        return removeItem(organizationIds, organization.id)
      }
      case getType(dataExtraction.success):
        return removeItem(organizationIds, action.payload)
      default:
        return organizationIds
    }
  },
  deletePopup: combineReducers<OrganizationsManagerDeletePopupState, OrganizationsManagerAction>({
    open: (open = false, action) => {
      switch (action.type) {
        case getType(openDeletePopup):
          return true
        case getType(closeDeletePopup):
          return false
        default:
          return open
      }
    },
    organizationId: (dealId = null, action) => {
      switch (action.type) {
        case getType(openDeletePopup):
          return action.payload.organizationId
        case getType(closeDeletePopup):
          return null
        default:
          return dealId
      }
    },
  }),
  components: combineReducers<OrganizationsManagerState['components']>({
    [ADD_ORGANIZATION_MODAL_STORE_ID]: addOrganizationModalReducer,
  }),
})
